/* eslint-disable quotes */
/* eslint-disable @typescript-eslint/quotes */


export class StubQuestionsService {
    constructor () { }

    allQuestions = [];

    getAllQuestions(): any {
        return [
            this.datepicker,
            this.incidentTime,
            this.amPm,
            this.approximateDateTime,
            this.dateOfLossStringBody,
            this.callMessageInfoNotification,
            this.causeOfLossStringBody,
            // this.policeFireInfo,
            this.lossCause,
            this.lossDescription
        ];
    }

    getDatepicker(): any {
        return [this.datepicker];
    }

    getJustOneQuestion(): any {
        return [this.callMessageInfoNotification];
    }

    getLossCauseAndDescription(): any {
        return [this.lossCause, this.lossDescription];
    }

    datepicker = {
        key: 'incidentDate',
        label: 'Incident date',
        required: false,
        order: 2,
        type: 'datepicker',
        optionaltext: false,
        maxDate: 'today',
        regEx: '^(0[1-9]|1[0-2])/(0[1-9]|[12][0-9]|3[01])/([0-9]{4})$'
    };

    incidentTime = {
        key: 'incidentTime',
        label: 'Incident time',
        required: true,
        order: 3,
        type: 'stringTextfield',
        optionaltext: false,
        regEx: '^(0[1-9]|1[0-2]):[0-5][0-9]$'
    };

    amPm = {
        key: 'amPm',
        label: 'AM/PM',
        required: true,
        order: 4,
        type: 'choiceRadio',
        options: [
            { key: 'am', value: 'AM' },
            { key: 'pm', value: 'PM' }
        ]
    };

    approximateDateTime = {
        key: 'approximateDateTime',
        required: false,
        order: 5,
        type: 'booleanCheckbox',
        options: [
            { key: 'approximate', value: 'This is an approximate date and time' }
        ]
    };

    dateOfLossStringBody = {
        key: 'dateOfLoss',
        order: 1,
        type: 'stringBody',
        messageHeader: 'Date of loss',
        messageBody: '10/10/2025'
    };

    causeOfLossStringBody = {
        key: 'causeOfLoss',
        order: 2,
        type: 'stringBody',
        messageHeader: 'Cause of loss',
        messageBody: 'Hail'
    };

    callMessageInfoNotification = {
        key: 'callMessage',
        order: 3,
        type: 'stringNotification',
        level: 'info',
        label: 'Please call us at 1-800-421-3535 to add more details regarding this incident.'
    };

    policeFireInfo = {
        type: "policeFireInfo",
        key: "policeFireDepartment",
        label: "You'll have the option to upload documents and photos later.",
        required: false,
        optionaltext: true,
        order: 5,
        condition: {
           "field": "policeFireDepartmentCalled",
           "value": "yes"
           }
    };

    lossDescription = {
            type: 'stringTextArea',
            key: 'lossDescription',
            label: 'Give us a brief description of what happened. We\'ll follow up later if we need more details.',
            required: true,
            order: 2,
            optionaltext: false,
            maxLength: 1000,
            regEx: '^(0[1-9]|1[0-2])/(0[1-9]|[12][0-9]|3[01])/([0-9]{4})$'
    };

    lossCause = {
        "type": "choiceRadioBoundedCentered",
        "key": "primaryDamage",
        "label": "Select the primary reason for the damage",
        "required": true,
        "order": 1,
        "options": [
            {
                "key": "hailWind",
                "value": "Hail or Wind",
                "description": "Damage from hail or wind"
            },
            {
                "key": "water",
                "value": "Water-related",
                "description": "Damage from water (weather or non-weather related) or freezing (burst pipes or ice dam)."
            },
            {
                "key": "fire",
                "value": "Fire, Smoke, or Explosion",
                "description": "Due to a fire (including wild fire and evacuation)."
            },
            {
                "key": "other",
                "value": "Other"
            }
        ]
    };
}
